import styled, { css } from 'styled-components'
import { TextFieldComponent } from '../TextFieldComponent'

export const TextFieldCapitalize = styled(TextFieldComponent)(
  () =>
    css`
      && {
        .MuiInputBase-input {
          text-transform: capitalize;
        }
      }
    `
)
